import m from "../../geodata/es2015/senegalLow";
window.am4geodata_senegalLow = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/senegalLow.js
// module id = null
// module chunks = 